
<template>
    <div
        class="promotional-images"
        :style="{backgroundImage: `url(${bg})`}"
    >
        <img class="lawyer-avatar" :src="lawyerInfo.personal_avatar">
        <div class="lawyer-info">
            <div class="row">
                <div class="name">{{ lawyerInfo.name }}</div>
                <div class="job">{{ lawyerInfo.lawyer_position }}</div>
            </div>
            <div class="row">
                <div
                    v-if="lawyerInfo.register_years"
                    class="work-year"
                >{{ lawyerInfo.register_years }}年从业经验</div>
                <div
                    v-if="lawyerInfo.register_years && lawyerInfo.register_law_firm"
                >&nbsp;&nbsp;·&nbsp;&nbsp;</div>
                <div class="law-firm">{{ lawyerInfo.register_law_firm }}</div>
            </div>
            <div v-if="isShowIdea && lawyerInfo.register_philosophy || lawyerInfo.register_domain" class="row">
                <!-- 擅长领域或者执业理念 -->
                <div class="domain">{{ isShowIdea ? lawyerInfo.register_philosophy : lawyerInfo.register_domain.replace(/\$/g, '·') }}</div>
            </div>
            <div class="row">
                <div class="phone">电话咨询：{{ lawyerInfo.mobile_number }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import {BG_ARR} from '../config/index';

export default {
    props: {
        lawyerInfo: {
            type: Object,
            default: () => {}
        },
        // 是否展示执业理念
        isShowIdea: {
            type: Boolean,
            default: false
        },
        // 支持传入背景图片
        background: {
            type: String,
            default: ''
        }
    },
    watch: {
        lawyerInfo: {
            handler(val) {
                this.bg = this.background || val?.appearance_config?.color_config?.back_ground || this.bgArr[1].value;
            },
            immediate: true
        }
    },
    data() {
        return {
            bgArr: BG_ARR,
            bg: ''
        };
    }
};
</script>

<style lang='less' scoped>
.promotional-images {
    display: flex;
    width: 679.68px;
    height: 177px;
    background-position: center center;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    border-radius: 8px;

    .lawyer-avatar {
        height: 140px;
        width: 140px;
        margin-left: 22%;
        margin-top: 10px;
    }

    .lawyer-info {
        margin-left: 21px;
        color: #fff;

        .row {
            display: flex;
            line-height: 1;
            align-items: flex-end;
            width: 280px;
            white-space: nowrap;

            .law-firm, .domain {
                .text-overflow-ellipsis(1);
            }

            &:not(:first-child) {
                margin-top: 13px;
            }

            &:first-child {
                margin-top: 24px;
            }

            .name {
                font-size: 21px;
                font-weight: bolder;
            }

            .job {
                font-size: 14px;
                margin-left: 4px;
                font-weight: bolder;
            }

            .domain {
                font-size: 12px;
                line-height: 12px;
            }

            .phone {
                height: 22px;
                padding: 0 10px;
                color: #422b16;
                font-size: 12px;
                line-height: 22px;
                text-align: center;
                border-radius: 2px;
                margin-top: 2px;
                transform: scale(0.8);
                transform-origin: left top;
                background: url('https://lvlin-base.cdn.bcebos.com/fe-saas/page/personal-info/btn_bg.png') no-repeat center center / 100% 100%;
            }
        }
    }
}
</style>
